/* global Vue */
Vue.config.debug = true;
Vue.config.devtools = true;
